import { Box, Card, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "moment/locale/id";
import { ProsesParkirResponse } from "../../constants/types";

interface ICardSubsProps {
    data: ProsesParkirResponse["data"];
}

const CardSubs = ({ data }: ICardSubsProps) => {
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));

    return (
        <Card
            variant="outlined"
            sx={{
                marginTop: 1,
                marginBottom: 1,
                padding: isTabletScreen ? 1 : 2,
            }}
        >
            <Box>
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        alignItems="center"
                    >
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                            >
                                Nama
                            </Typography>
                            <Typography variant="body1">
                                {data?.namaMember}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                            >
                                Nomor Polisi
                            </Typography>
                            <Typography variant="body1">
                                {data?.noPolisi}
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                            >
                                Jenis Langganan
                            </Typography>
                            <Typography variant="body1">
                                {data?.jenislanggananId.nama}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                            >
                                Berlaku Sampai
                            </Typography>
                            <Typography variant="body1">
                                {data?.endLangganan
                                    ? moment(data.endLangganan).format(
                                          "DD MMM YYYY",
                                      )
                                    : "-"}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};

export default CardSubs;
